import 'react';
import { Button, Text } from 'reaxl';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
var SacaFinancingCTA = () => /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx(Button, {
    bsStyle: "text",
    children: "Apply for Financing"
  }), /*#__PURE__*/jsx(Text, {
    children: " to see all available lenders from this dealer and compare rates on your next vehicle."
  })]
});
export { SacaFinancingCTA as default };
